import React from 'react';
import TabularDataSection from './TabularDataSection.js';

export default function TabularDataViews(props) {
	const tableData = props.tableData;
	if (tableData && tableData.sections !== null) {
		const TableSections = tableData.sections.map((section, indx) => {
			return <TabularDataSection key={indx} tableData={tableData} section={section} compareItems={props.compareItems} />;
		});

		return (
			<section className="comparison-feature trailer-3 grid-container" aria-expanded="true">
				{TableSections}
				<div className="feature-post-script">
					{/* PLACE HOLDER FOR FUTURE COMPARISON TABLE MESSAGES */}
					<p className="font-1 text-blue leader-3"></p>
				</div>
			</section>
		);
	} else {
		console.error('%c There may be a problem with the data api, please check source! ', 'background: orange; color: black');
		return null;
	}
}
